import React from 'react'
import { withStyles } from 'material-ui/styles'
import styles from './styles'

const LinkBudgetCalculator = ({ classes }) => {
  React.useEffect(() => {
    console.log('LinkBudgetCalculator component mounted')
  }, [])
  
  return (
    <div className={classes.container}>
      <h1>Link Budget Calculator - Fiber Loss & Link Budget Analysis</h1>
      <p>Link Budget Calculator tool coming soon...</p>
    </div>
  )
}

export default withStyles(styles)(LinkBudgetCalculator)
